export const DASHBOARD_LOADING_ACTION = "DASHBOARD_LOADING";
export const PAYMENT_LIST_ACTION = "PAYMENT_LIST_ACTION";
export const PAYMENT_LIST_LOADING = "PAYMENT_LIST_LOADING";
export const PAYMENT_LIST_SUCCESS = "PAYMENT_LIST_SUCCESS";
export const PAYMENT_LIST_ERROR = "PAYMENT_LIST_ERROR";

export const PAYMENT_DOWNLOAD_ACTION = "PAYMENT_DOWNLOAD_ACTION";
export const PAYMENT_DOWNLOAD_LOADING = "PAYMENT_DOWNLOAD_LOADING";
export const PAYMENT_DOWNLOAD_SUCCESS = "PAYMENT_DOWNLOAD_SUCCESS";
export const PAYMENT_DOWNLOAD_ERROR = "PAYMENT_DOWNLOAD_ERROR";
export const PAYMENT_DOWNLOAD_RESET_ACTION = "PAYMENT_DOWNLOAD_RESET_ACTION";

export const GET_PAYMENT_ACTION = "GET_PAYMENT_ACTION";
export const GET_PAYMENT_LOADING = "GET_PAYMENT_LOADING";
export const GET_PAYMENT_SUCCESS = "GET_PAYMENT_SUCCESS";
export const GET_PAYMENT_ERROR = "GET_PAYMENT_ERROR";

export const SETTLE_PAYMENT_ACTION = "SETTLE_PAYMENT_ACTION";
export const SETTLE_PAYMENT_LOADING = "SETTLE_PAYMENT_LOADING";
export const SETTLE_PAYMENT_SUCCESS = "SETTLE_PAYMENT_SUCCESS";
export const SETTLE_PAYMENT_ERROR = "SETTLE_PAYMENT_ERROR";

export const SETTLE_SALARY_ACTION = "SETTLE_SALARY_ACTION";
export const SETTLE_SALARY_LOADING = "SETTLE_SALARY_LOADING";
export const SETTLE_SALARY_SUCCESS = "SETTLE_SALARY_SUCCESS";
export const SETTLE_SALARY_ERROR = "SETTLE_SALARY_ERROR";

export const BULK_SETTLE_SALARY_ACTION = "BULK_SETTLE_SALARY_ACTION";
export const BULK_SETTLE_SALARY_LOADING = "BULK_SETTLE_SALARY_LOADING";
export const BULK_SETTLE_SALARY_SUCCESS = "BULK_SETTLE_SALARY_SUCCESS";
export const BULK_SETTLE_SALARY_ERROR = "BULK_SETTLE_SALARY_ERROR";

export const MONTHS_TO_SETTLE_ACTION = "MONTHS_TO_SETTLE_ACTION";
export const MONTHS_TO_SETTLE_LOADING = "MONTHS_TO_SETTLE_LOADING";
export const MONTHS_TO_SETTLE_SUCCESS = "MONTHS_TO_SETTLE_SUCCESS";
export const MONTHS_TO_SETTLE_ERROR = "MONTHS_TO_SETTLE_ERROR";

export const BULK_MONTHS_TO_SETTLE_ACTION = "BULK_MONTHS_TO_SETTLE_ACTION";
export const BULK_MONTHS_TO_SETTLE_LOADING = "BULK_MONTHS_TO_SETTLE_LOADING";
export const BULK_MONTHS_TO_SETTLE_SUCCESS = "BULK_MONTHS_TO_SETTLE_SUCCESS";
export const BULK_MONTHS_TO_SETTLE_ERROR = "BULK_MONTHS_TO_SETTLE_ERROR";

export const COMPANY_LIST_ACTION = "COMPANY_LIST_ACTION";
export const COMPANY_LIST_LOADING = "COMPANY_LIST_LOADING";
export const COMPANY_LIST_SUCCESS = "COMPANY_LIST_SUCCESS";
export const COMPANY_LIST_ERROR = "COMPANY_LIST_ERROR";

export const GET_COMPANY_ACTION = "GET_COMPANY_ACTION";
export const GET_COMPANY_LOADING = "GET_COMPANY_LOADING";
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS";
export const GET_COMPANY_ERROR = "GET_COMPANY_ERROR";

export const UPDATE_COMPANY_ACTION = "UPDATE_COMPANY_ACTION";
export const UPDATE_COMPANY_LOADING = "UPDATE_COMPANY_LOADING";
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_ERROR = "UPDATE_COMPANY_ERROR";

export const EMPLOYEE_LIST_ACTION = "EMPLOYEE_LIST_ACTION";
export const EMPLOYEE_LIST_LOADING = "EMPLOYEE_LIST_LOADING";
export const EMPLOYEE_LIST_SUCCESS = "EMPLOYEE_LIST_SUCCESS";
export const EMPLOYEE_LIST_ERROR = "EMPLOYEE_LIST_ERROR";

export const GET_EMPLOYEE_ACTION = "GET_EMPLOYEE_ACTION";
export const GET_EMPLOYEE_LOADING = "GET_EMPLOYEE_LOADING";
export const GET_EMPLOYEE_SUCCESS = "GET_EMPLOYEE_SUCCESS";
export const GET_EMPLOYEE_ERROR = "GET_EMPLOYEE_ERROR";

export const OVERVIEW_ACTION = "OVERVIEW_ACTION";
export const OVERVIEW_LOADING = "OVERVIEW_LOADING";
export const OVERVIEW_SUCCESS = "OVERVIEW_SUCCESS";
export const OVERVIEW_ERROR = "OVERVIEW_ERROR";

export const INVITE_COMPANY_ACTION = "INVITE_COMPANY_ACTION";
export const INVITE_COMPANY_LOADING = "INVITE_COMPANY_LOADING";
export const INVITE_COMPANY_SUCCESS = "INVITE_COMPANY_SUCCESS";
export const INVITE_COMPANY_ERROR = "INVITE_COMPANY_ERROR";

export const EXCHANGE_LIST_ACTION = "EXCHANGE_LIST_ACTION";
export const EXCHANGE_LIST_LOADING = "EXCHANGE_LIST_LOADING";
export const EXCHANGE_LIST_SUCCESS = "EXCHANGE_LIST_SUCCESS";
export const EXCHANGE_LIST_ERROR = "EXCHANGE_LIST_ERROR";

export const GET_EXCHANGE_ACTION = "GET_EXCHANGE_ACTION";
export const GET_EXCHANGE_LOADING = "GET_EXCHANGE_LOADING";
export const GET_EXCHANGE_SUCCESS = "GET_EXCHANGE_SUCCESS";
export const GET_EXCHANGE_ERROR = "GET_EXCHANGE_ERROR";

export const CREATE_EXCHANGE_ACTION = "CREATE_EXCHANGE_ACTION";
export const CREATE_EXCHANGE_LOADING = "CREATE_EXCHANGE_LOADING";
export const CREATE_EXCHANGE_SUCCESS = "CREATE_EXCHANGE_SUCCESS";
export const CREATE_EXCHANGE_ERROR = "CREATE_EXCHANGE_ERROR";

export const UPDATE_EXCHANGE_ACTION = "UPDATE_EXCHANGE_ACTION";
export const UPDATE_EXCHANGE_LOADING = "UPDATE_EXCHANGE_LOADING";
export const UPDATE_EXCHANGE_SUCCESS = "UPDATE_EXCHANGE_SUCCESS";
export const UPDATE_EXCHANGE_ERROR = "UPDATE_EXCHANGE_ERROR";

export const DELETE_EXCHANGE_ACTION = "DELETE_EXCHANGE_ACTION";
export const DELETE_EXCHANGE_LOADING = "DELETE_EXCHANGE_LOADING";
export const DELETE_EXCHANGE_SUCCESS = "DELETE_EXCHANGE_SUCCESS";
export const DELETE_EXCHANGE_ERROR = "DELETE_EXCHANGE_ERROR";


export const BACKOFFICE_DEDUCTION_LIST_ACTION =
  "BACKOFFICE_DEDUCTION_LIST_ACTION";
export const BACKOFFICE_DEDUCTION_LIST_LOADING =
  "BACKOFFICE_DEDUCTION_LIST_LOADING";
export const BACKOFFICE_DEDUCTION_LIST_SUCCESS =
  "BACKOFFICE_DEDUCTION_LIST_SUCCESS";
export const BACKOFFICE_DEDUCTION_LIST_ERROR =
  "BACKOFFICE_DEDUCTION_LIST_ERROR";

export const GET_DEDUCTION_ACTION = "GET_DEDUCTION_ACTION";
export const GET_DEDUCTION_LOADING = "GET_DEDUCTION_LOADING";
export const GET_DEDUCTION_SUCCESS = "GET_DEDUCTION_SUCCESS";
export const GET_DEDUCTION_ERROR = "GET_DEDUCTION_ERROR";

export const CREATE_DEDUCTION_ACTION = "CREATE_DEDUCTION_ACTION";
export const CREATE_DEDUCTION_LOADING = "CREATE_DEDUCTION_LOADING";
export const CREATE_DEDUCTION_SUCCESS = "CREATE_DEDUCTION_SUCCESS";
export const CREATE_DEDUCTION_ERROR = "CREATE_DEDUCTION_ERROR";

export const UPDATE_DEDUCTION_ACTION = "UPDATE_DEDUCTION_ACTION";
export const UPDATE_DEDUCTION_LOADING = "UPDATE_DEDUCTION_LOADING";
export const UPDATE_DEDUCTION_SUCCESS = "UPDATE_DEDUCTION_SUCCESS";
export const UPDATE_DEDUCTION_ERROR = "UPDATE_DEDUCTION_ERROR";

export const DELETE_DEDUCTION_ACTION = "DELETE_DEDUCTION_ACTION";
export const DELETE_DEDUCTION_LOADING = "DELETE_DEDUCTION_LOADING";
export const DELETE_DEDUCTION_SUCCESS = "DELETE_DEDUCTION_SUCCESS";
export const DELETE_DEDUCTION_ERROR = "DELETE_DEDUCTION_ERROR";

export const OVERVIEW_FILTER_ACTION = "OVERVIEW_FILTER_ACTION";
export const OVERVIEW_FILTER_SUCCESS = "OVERVIEW_FILTER_SUCCESS";
export const TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_ACTION =
  "TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_ACTION";
export const TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_SUCCESS =
  "TRANSACTIONS_WITHDRAWAL_REQUESTS_FILTER_SUCCESS";
export const TRANSACTIONS_OVERTIME_REQUESTS_FILTER_ACTION =
  "TRANSACTIONS_OVERTIME_REQUESTS_FILTER_ACTION";
export const TRANSACTIONS_OVERTIME_REQUESTS_FILTER_SUCCESS =
  "TRANSACTIONS_OVERTIME_REQUESTS_FILTER_SUCCESS";

export const TRANSACTION_HISTORY_ACTION = "TRANSACTION_HISTORY_ACTION";
export const TRANSACTION_HISTORY_LOADING = "TRANSACTION_HISTORY_LOADING";
export const TRANSACTION_HISTORY_SUCCESS = "TRANSACTION_HISTORY_SUCCESS";
export const TRANSACTION_HISTORY_ERROR = "TRANSACTION_HISTORY_ERROR";

export const BACKOFFICE_COUNTRY_FEES_LIST_ACTION =
  "BACKOFFICE_COUNTRY_FEES_LIST_ACTION";
export const BACKOFFICE_COUNTRY_FEES_LIST_LOADING =
  "BACKOFFICE_COUNTRY_FEES_LIST_LOADING";
export const BACKOFFICE_COUNTRY_FEES_LIST_SUCCESS =
  "BACKOFFICE_COUNTRY_FEES_LIST_SUCCESS";
export const BACKOFFICE_COUNTRY_FEES_LIST_ERROR =
  "BACKOFFICE_COUNTRY_FEES_LIST_ERROR";
export const CREATE_COUNTRY_FEES_ACTION = "CREATE_COUNTRY_FEES_ACTION";
export const CREATE_COUNTRY_FEES_LOADING = "CREATE_COUNTRY_FEES_LOADING";
export const CREATE_COUNTRY_FEES_SUCCESS = "CREATE_COUNTRY_FEES_SUCCESS";
export const CREATE_COUNTRY_FEES_ERROR = "CREATE_COUNTRY_FEES_ERROR";

export const UPDATE_COUNTRY_FEES_ACTION = "UPDATE_COUNTRY_FEES_ACTION";
export const UPDATE_COUNTRY_FEES_LOADING = "UPDATE_COUNTRY_FEES_LOADING";
export const UPDATE_COUNTRY_FEES_SUCCESS = "UPDATE_COUNTRY_FEES_SUCCESS";
export const UPDATE_COUNTRY_FEES_ERROR = "UPDATE_COUNTRY_FEES_ERROR";

export const PAYMENT_SUB_TABLE_LIST_SUCCESS = "PAYMENT_SUB_TABLE_LIST_SUCCESS";
export const PAYMENT_SUB_TABLE_LIST_ERROR = "PAYMENT_SUB_TABLE__LIST_ERROR";
export const PAYMENT_SUB_TABLE_LIST_LOADING = "PAYMENT_SUB_TABLE_LIST_LOADING";
export const PAYMENT_SUB_TABLE_LIST_ACTION = "PAYMENT_SUB_TABLE_LIST_ACTION";


export const DECLINE_PAYMENT_ACTION = "DECLINE_PAYMENT_ACTION";
export const DECLINE_PAYMENT_LOADING = "DECLINE_PAYMENT_LOADING";
export const DECLINE_PAYMENT_SUCCESS = "DECLINE_PAYMENT_SUCCESS";
export const DECLINE_PAYMENT_ERROR = "DECLINE_PAYMENT_ERROR";

export const GET_REPORTS_ACTION = "GET_REPORTS_ACTION";
export const GET_REPORTS_LOADING = "GET_REPORTS_LOADING";
export const GET_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS";
export const GET_REPORTS_ERROR = "GET_REPORTS_ERROR";

export const PUSH_NOTIFICATION_ACTION = "PUSH_NOTIFICATION_ACTION";
export const PUSH_NOTIFICATION_LOADING = "PUSH_NOTIFICATION_LOADING";
export const PUSH_NOTFICATION_SUCCESS = "PUSH_NOTIFICATION_SUCCESS";
export const PUSH_NOTIFICATION_ERROR = "PUSH_NOTIFICATION_ERROR";

export const SEND_MONTHLY_COMPANY_REPORTS_ACTION = "SEND_MONTHLY_COMPANY_REPORTS_ACTION";
export const SEND_MONTHLY_COMPANY_REPORTS_LOADING = "SEND_MONTHLY_COMPANY_REPORTS_LOADING";
export const SEND_MONTHLY_COMPANY_REPORTS_SUCCESS = "SEND_MONTHLY_COMPANY_REPORTS_SUCCESS";
export const SEND_MONTHLY_COMPANY_REPORTS_ERROR = "SEND_MONTHLY_COMPANY_REPORTS_ERROR";

export const SEND_CUSTOM_COMPANY_REPORTS_ACTION = "SEND_CUSTOM_COMPANY_REPORTS_ACTION";
export const SEND_CUSTOM_COMPANY_REPORTS_SUCCESS = "SEND_CUSTOM_COMPANY_REPORTS_SUCCESS";
export const SEND_CUSTOM_COMPANY_REPORTS_LOADING = "SEND_CUSTOM_COMPANY_REPORTS_LOADING";
export const SEND_CUSTOM_COMPANY_REPORTS_ERROR = "SEND_CUSTOM_COMPANY_REPORTS_ERROR";

export const GET_PAYMENTS_COUNT_ACTION = "GET_PAYMENTS_COUNT_ACTION";
export const GET_PAYMENTS_COUNT_LOADING = "GET_PAYMENTS_COUNT_LOADING";
export const GET_PAYMENTS_COUNT_ERROR = "GET_PAYMENTS_COUNT_ERROR";
export const GET_PAYMENTS_COUNT_SUCCESS = "GET_PAYMENTS_COUNT_SUCCESS";

export const UPDATE_COMPANY_PAYMENT_ACTION = "UPDATE_COMPANY_PAYMENT_ACTION";
export const UPDATE_COMPANY_PAYMENT_LOADING = "UPDATE_COMPANY_PAYMENT_LOADING";
export const UPDATE_COMPANY_PAYMENT_ERROR = "UPDATE_COMPANY_PAYMENT_ERROR";
export const UPDATE_COMPANY_PAYMENT_SUCCESS = "UPDATE_COMPANY_PAYMENT_SUCCESS";

export const GET_WITHDRAWAL_CATEGORIES_ACTION = "GET_WITHDRAWAL_CATEGORIES_ACTION";
export const GET_WITHDRAWAL_CATEGORIES_LOADING = "GET_WITHDRAWAL_CATEGORIES_LOADING";
export const GET_WITHDRAWAL_CATEGORIES_ERROR = "GET_WITHDRAWAL_CATEGORIES_ERROR";
export const GET_WITHDRAWAL_CATEGORIES_SUCCESS = "GET_WITHDRAWAL_CATEGORIES_SUCCESS";

export const CREATE_WITHDRAWAL_CATEGORY_ACTION = "CREATE_WITHDRAWAL_CATEGORY_ACTION";
export const CREATE_WITHDRAWAL_CATEGORY_LOADING = "CREATE_WITHDRAWAL_CATEGORY_LOADING";
export const CREATE_WITHDRAWAL_CATEGORY_ERROR = "CREATE_WITHDRAWAL_CATEGORY_ERROR";
export const CREATE_WITHDRAWAL_CATEGORY_SUCCESS = "CREATE_WITHDRAWAL_CATEGORY_SUCESS";

export const UPDATE_WITHDRAWAL_CATEGORY_ACTION = "UPDATE_WITHDRAWAL_CATEGORY_ACTION";
export const UPDATE_WITHDRAWAL_CATEGORY_LOADING = "UPDATE_WITHDRAWAL_CATEGORY_LOADING";
export const UPDATE_WITHDRAWAL_CATEGORY_ERROR = "UPDATE_WITHDRAWAL_CATEGORY_ERROR";
export const UPDATE_WITHDRAWAL_CATEGORY_SUCCESS = "UPDATE_WITHDRAWAL_CATEGORY_SUCCESS";

export const MERCHANT_LIST_ACTION = "MERCHANT_LIST_ACTION";
export const MERCHANT_LIST_LOADING = "MERCHANT_LIST_LOADING";
export const MERCHANT_LIST_SUCCESS = "MERCHANT_LIST_SUCCESS";
export const MERCHANT_LIST_ERROR = "MERCHANT_LIST_ERROR";

export const GET_MERCHANT_ACTION = "GET_MERCHANT_ACTION";
export const GET_MERCHANT_LOADING = "GET_MERCHANT_LOADING";
export const GET_MERCHANT_SUCCESS = "GET_MERCHANT_SUCCESS";
export const GET_MERCHANT_ERROR = "GET_MERCHANT_ERROR";

export const INVITE_MERCHANT_ACTION = "INVITE_MERCHANT_ACTION";
export const INVITE_MERCHANT_LOADING = "INVITE_MERCHANT_LOADING";
export const INVITE_MERCHANT_SUCCESS = "INVITE_MERCHANT_SUCCESS";
export const INVITE_MERCHANT_ERROR = "INVITE_MERCHANT_ERROR";

export const UPDATE_MERCHANT_ACTION = "UPDATE_MERCHANT_ACTION";
export const UPDATE_MERCHANT_LOADING = "UPDATE_MERCHANT_LOADING";
export const UPDATE_MERCHANT_SUCCESS = "UPDATE_MERCHANT_SUCCESS";
export const UPDATE_MERCHANT_ERROR = "UPDATE_MERCHANT_ERROR";

export const REACTIVATE_VENDOR_ACTION = "REACTIVATE_VENDOR_ACTION";
export const REACTIVATE_VENDOR_LOADING = "REACTIVATE_VENDOR_LOADING";
export const REACTIVATE_VENDOR_SUCCESS = "REACTIVATE_VENDOR_SUCCESS";
export const REACTIVATE_VENDOR_ERROR = "REACTIVATE_VENDOR_ERROR";

export const SUSPEND_VENDOR_ACTION = "SUSPEND_VENDOR_ACTION";
export const SUSPEND_VENDOR_LOADING = "SUSPEND_VENDOR_LOADING";
export const SUSPEND_VENDOR_SUCCESS = "SUSPEND_VENDOR_SUCCESS";
export const SUSPEND_VENDOR_ERROR = "SUSPEND_VENDOR_ERROR";

export const constants = buildTypeConstants([
  "GET_WITHDRAWAL_CATEGORY",
  "DELETE_WITHDRAWAL_CATEGORY",
  "PROMOTE_HR_TO_ADMIN",
  "GET_USER_ACTIVITY_LOGS",
  "GET_VENDOR_PAYMENTS",
  "GET_VENDOR_FEES",
  "CREATE_VENDOR_FEES",
  "UPDATE_VENDOR_FEES",
  "DELETE_VENDOR_FEES",
  "GET_VENDOR_SETTLEMENTS",
  "GET_PAYSTACK_BANKS_LIST",
  "VERIFY_PAYSTACK_BANK_ACCOUNT",
  "ADD_VENDOR_BANK_DETAILS",
  "UPDATE_VENDOR_BANK_DETAILS",
  "DELETE_VENDOR_BANK_DETAILS",
  "GET_VENDOR_BANK_DETAILS",
  "LIST_VENDOR_BANK_DETAILS",
  "VENDOR_SETTLEMENT_TRIGGER",
  "VENDOR_RESEND_INVITATION",
  "VENDOR_SETTLEMENT_TRIGGER_AGGREGATE",
  "ONBOARD_COMPANY_EMPLOYEES",
  "BONUS_LIST",
  "GET_BONUS",
  "CREATE_BONUS",
  "UPDATE_BONUS",
  "DELETE_BONUS",
  "BONUS_CLAIM_LIST",
  "GET_BONUS_CLAIM",
  "DELETE_BONUS_CLAIM",
  "CAMPAIGN_CONFIG_REQUEST",
  "CAMPAIGN_LIST_REQUEST",
  "CAMPAIGN_DETAIL_REQUEST",
  "CAMPAIGN_CREATE_REQUEST",
  "CAMPAIGN_UPDATE_REQUEST",
  "CAMPAIGN_ACTION_REQUEST",
  "CAMPAIGN_STATS_REQUEST",
  "CAMPAIGN_HISTORY_REQUEST",
  "CAMPAIGN_SET_FILTERS",
  "CAMPAIGN_SET_PAGINATION",
  "CAMPAIGN_SET_HISTORY_PAGINATION",
  "CAMPAIGN_RESET_FORM_ERRORS",
  "CAMPAIGN_CLEAR_TOAST",
  "PERMISSION_CATALOGUE",
  "GROUP_LIST",
  "GET_GROUP",
  "CREATE_GROUP",
  "UPDATE_GROUP",
  "DELETE_GROUP",
  "GROUP_MEMBER_LIST",
  "ADD_GROUP_MEMBERS",
  "REMOVE_GROUP_MEMBERS",
  "NOTIFICATION_COUNT",
  "NOTIFICATION_LIST",
  "MARK_NOTIFICATION_READ",
  "MARK_ALL_NOTIFICATIONS_READ",
  // Payment-gateway config (Fortress) — super-only backoffice.
  "GET_FORTRESS_COMPANIES",
  "UPDATE_FORTRESS_COMPANIES",
  "FORTRESS_BANK_CODE_LIST",
  "UPDATE_FORTRESS_BANK_CODE",
  // Backoffice: download an employee's payment statement as a PDF (blob).
  "DOWNLOAD_EMPLOYEE_STATEMENT",
  // Company fee ranges (backoffice /companies/fees) — mirrors the vendor fees flow.
  "GET_COMPANY_FEES",
  "CREATE_COMPANY_FEES",
  "UPDATE_COMPANY_FEES",
  "DELETE_COMPANY_FEES"
]);

export const {
  DELETE_WITHDRAWAL_CATEGORY_ACTION,
  DELETE_WITHDRAWAL_CATEGORY_ERROR,
  DELETE_WITHDRAWAL_CATEGORY_LOADING,
  DELETE_WITHDRAWAL_CATEGORY_SUCCESS,
  GET_WITHDRAWAL_CATEGORY_ACTION,
  GET_WITHDRAWAL_CATEGORY_SUCCESS,
  GET_WITHDRAWAL_CATEGORY_ERROR,
  GET_WITHDRAWAL_CATEGORY_LOADING,
  PROMOTE_HR_TO_ADMIN_ACTION,
  PROMOTE_HR_TO_ADMIN_LOADING,
  PROMOTE_HR_TO_ADMIN_ERROR,
  PROMOTE_HR_TO_ADMIN_SUCCESS,
  GET_USER_ACTIVITY_LOGS_ACTION,
  GET_USER_ACTIVITY_LOGS_ERROR,
  GET_USER_ACTIVITY_LOGS_SUCCESS,
  GET_USER_ACTIVITY_LOGS_LOADING,
  GET_VENDOR_PAYMENTS_ACTION,
  GET_VENDOR_PAYMENTS_ERROR,
  GET_VENDOR_PAYMENTS_SUCCESS,
  GET_VENDOR_PAYMENTS_LOADING,
  GET_VENDOR_FEES_ACTION,
  GET_VENDOR_FEES_ERROR,
  GET_VENDOR_FEES_SUCCESS,
  GET_VENDOR_FEES_LOADING,
  CREATE_VENDOR_FEES_ACTION,
  CREATE_VENDOR_FEES_ERROR,
  CREATE_VENDOR_FEES_SUCCESS,
  CREATE_VENDOR_FEES_LOADING,
  UPDATE_VENDOR_FEES_ACTION,
  UPDATE_VENDOR_FEES_ERROR,
  UPDATE_VENDOR_FEES_SUCCESS,
  UPDATE_VENDOR_FEES_LOADING,
  DELETE_VENDOR_FEES_ACTION,
  DELETE_VENDOR_FEES_ERROR,
  DELETE_VENDOR_FEES_SUCCESS,
  DELETE_VENDOR_FEES_LOADING,
  GET_VENDOR_SETTLEMENTS_ACTION,
  GET_VENDOR_SETTLEMENTS_ERROR,
  GET_VENDOR_SETTLEMENTS_SUCCESS,
  GET_VENDOR_SETTLEMENTS_LOADING,
  ADD_VENDOR_BANK_DETAILS_ACTION,
  ADD_VENDOR_BANK_DETAILS_ERROR,
  ADD_VENDOR_BANK_DETAILS_SUCCESS,
  ADD_VENDOR_BANK_DETAILS_LOADING,
  UPDATE_VENDOR_BANK_DETAILS_ACTION,
  UPDATE_VENDOR_BANK_DETAILS_ERROR,
  UPDATE_VENDOR_BANK_DETAILS_SUCCESS,
  UPDATE_VENDOR_BANK_DETAILS_LOADING,
  DELETE_VENDOR_BANK_DETAILS_ACTION,
  DELETE_VENDOR_BANK_DETAILS_ERROR,
  DELETE_VENDOR_BANK_DETAILS_SUCCESS,
  DELETE_VENDOR_BANK_DETAILS_LOADING,
  GET_VENDOR_BANK_DETAILS_ACTION,
  GET_VENDOR_BANK_DETAILS_ERROR,
  GET_VENDOR_BANK_DETAILS_SUCCESS,
  GET_VENDOR_BANK_DETAILS_LOADING,
  LIST_VENDOR_BANK_DETAILS_ACTION,
  LIST_VENDOR_BANK_DETAILS_ERROR,
  LIST_VENDOR_BANK_DETAILS_SUCCESS,
  LIST_VENDOR_BANK_DETAILS_LOADING,
  GET_PAYSTACK_BANKS_LIST_ACTION,
  GET_PAYSTACK_BANKS_LIST_ERROR,
  GET_PAYSTACK_BANKS_LIST_SUCCESS,
  GET_PAYSTACK_BANKS_LIST_LOADING,
  VERIFY_PAYSTACK_BANK_ACCOUNT_ACTION,
  VERIFY_PAYSTACK_BANK_ACCOUNT_ERROR,
  VERIFY_PAYSTACK_BANK_ACCOUNT_SUCCESS,
  VERIFY_PAYSTACK_BANK_ACCOUNT_LOADING,
  VENDOR_SETTLEMENT_TRIGGER_ACTION,
  VENDOR_SETTLEMENT_TRIGGER_ERROR,
  VENDOR_SETTLEMENT_TRIGGER_SUCCESS,
  VENDOR_SETTLEMENT_TRIGGER_LOADING,
  VENDOR_RESEND_INVITATION_ACTION,
  VENDOR_RESEND_INVITATION_ERROR,
  VENDOR_RESEND_INVITATION_SUCCESS,
  VENDOR_RESEND_INVITATION_LOADING,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ACTION,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_ERROR,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_SUCCESS,
  VENDOR_SETTLEMENT_TRIGGER_AGGREGATE_LOADING,
  ONBOARD_COMPANY_EMPLOYEES_ACTION,
  ONBOARD_COMPANY_EMPLOYEES_ERROR,
  ONBOARD_COMPANY_EMPLOYEES_SUCCESS,
  ONBOARD_COMPANY_EMPLOYEES_LOADING,

  BONUS_LIST_ACTION,
  BONUS_LIST_ERROR,
  BONUS_LIST_SUCCESS,
  BONUS_LIST_LOADING,
  GET_BONUS_ACTION,
  GET_BONUS_ERROR,
  GET_BONUS_SUCCESS,
  GET_BONUS_LOADING,
  CREATE_BONUS_ACTION,
  CREATE_BONUS_ERROR,
  CREATE_BONUS_SUCCESS,
  CREATE_BONUS_LOADING,
  UPDATE_BONUS_ACTION,
  UPDATE_BONUS_ERROR,
  UPDATE_BONUS_SUCCESS,
  UPDATE_BONUS_LOADING,
  DELETE_BONUS_ACTION,
  DELETE_BONUS_ERROR,
  DELETE_BONUS_SUCCESS,
  DELETE_BONUS_LOADING,
  BONUS_CLAIM_LIST_ACTION,
  BONUS_CLAIM_LIST_ERROR,
  BONUS_CLAIM_LIST_SUCCESS,
  BONUS_CLAIM_LIST_LOADING,
  GET_BONUS_CLAIM_ACTION,
  GET_BONUS_CLAIM_ERROR,
  GET_BONUS_CLAIM_SUCCESS,
  GET_BONUS_CLAIM_LOADING,
  DELETE_BONUS_CLAIM_ACTION,
  DELETE_BONUS_CLAIM_ERROR,
  DELETE_BONUS_CLAIM_SUCCESS,
  DELETE_BONUS_CLAIM_LOADING,

  CAMPAIGN_CONFIG_REQUEST_ACTION,
  CAMPAIGN_CONFIG_REQUEST_ERROR,
  CAMPAIGN_CONFIG_REQUEST_SUCCESS,
  CAMPAIGN_CONFIG_REQUEST_LOADING,
  CAMPAIGN_LIST_REQUEST_ACTION,
  CAMPAIGN_LIST_REQUEST_ERROR,
  CAMPAIGN_LIST_REQUEST_SUCCESS,
  CAMPAIGN_LIST_REQUEST_LOADING,
  CAMPAIGN_DETAIL_REQUEST_ACTION,
  CAMPAIGN_DETAIL_REQUEST_ERROR,
  CAMPAIGN_DETAIL_REQUEST_SUCCESS,
  CAMPAIGN_DETAIL_REQUEST_LOADING,
  CAMPAIGN_CREATE_REQUEST_ACTION,
  CAMPAIGN_CREATE_REQUEST_ERROR,
  CAMPAIGN_CREATE_REQUEST_SUCCESS,
  CAMPAIGN_CREATE_REQUEST_LOADING,
  CAMPAIGN_UPDATE_REQUEST_ACTION,
  CAMPAIGN_UPDATE_REQUEST_ERROR,
  CAMPAIGN_UPDATE_REQUEST_SUCCESS,
  CAMPAIGN_UPDATE_REQUEST_LOADING,
  CAMPAIGN_ACTION_REQUEST_ACTION,
  CAMPAIGN_ACTION_REQUEST_ERROR,
  CAMPAIGN_ACTION_REQUEST_SUCCESS,
  CAMPAIGN_ACTION_REQUEST_LOADING,
  CAMPAIGN_STATS_REQUEST_ACTION,
  CAMPAIGN_STATS_REQUEST_ERROR,
  CAMPAIGN_STATS_REQUEST_SUCCESS,
  CAMPAIGN_STATS_REQUEST_LOADING,
  CAMPAIGN_HISTORY_REQUEST_ACTION,
  CAMPAIGN_HISTORY_REQUEST_ERROR,
  CAMPAIGN_HISTORY_REQUEST_SUCCESS,
  CAMPAIGN_HISTORY_REQUEST_LOADING,
  CAMPAIGN_SET_FILTERS_ACTION,
  CAMPAIGN_SET_FILTERS_ERROR,
  CAMPAIGN_SET_FILTERS_SUCCESS,
  CAMPAIGN_SET_FILTERS_LOADING,
  CAMPAIGN_SET_PAGINATION_ACTION,
  CAMPAIGN_SET_PAGINATION_ERROR,
  CAMPAIGN_SET_PAGINATION_SUCCESS,
  CAMPAIGN_SET_PAGINATION_LOADING,
  CAMPAIGN_SET_HISTORY_PAGINATION_ACTION,
  CAMPAIGN_SET_HISTORY_PAGINATION_ERROR,
  CAMPAIGN_SET_HISTORY_PAGINATION_SUCCESS,
  CAMPAIGN_SET_HISTORY_PAGINATION_LOADING,
  CAMPAIGN_RESET_FORM_ERRORS_ACTION,
  CAMPAIGN_RESET_FORM_ERRORS_ERROR,
  CAMPAIGN_RESET_FORM_ERRORS_SUCCESS,
  CAMPAIGN_RESET_FORM_ERRORS_LOADING,
  CAMPAIGN_CLEAR_TOAST_ACTION,
  CAMPAIGN_CLEAR_TOAST_ERROR,
  CAMPAIGN_CLEAR_TOAST_SUCCESS,
  CAMPAIGN_CLEAR_TOAST_LOADING,

  PERMISSION_CATALOGUE_ACTION,
  PERMISSION_CATALOGUE_ERROR,
  PERMISSION_CATALOGUE_SUCCESS,
  PERMISSION_CATALOGUE_LOADING,
  GROUP_LIST_ACTION,
  GROUP_LIST_ERROR,
  GROUP_LIST_SUCCESS,
  GROUP_LIST_LOADING,
  GET_GROUP_ACTION,
  GET_GROUP_ERROR,
  GET_GROUP_SUCCESS,
  GET_GROUP_LOADING,
  CREATE_GROUP_ACTION,
  CREATE_GROUP_ERROR,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_LOADING,
  UPDATE_GROUP_ACTION,
  UPDATE_GROUP_ERROR,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_LOADING,
  DELETE_GROUP_ACTION,
  DELETE_GROUP_ERROR,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_LOADING,
  GROUP_MEMBER_LIST_ACTION,
  GROUP_MEMBER_LIST_ERROR,
  GROUP_MEMBER_LIST_SUCCESS,
  GROUP_MEMBER_LIST_LOADING,
  ADD_GROUP_MEMBERS_ACTION,
  ADD_GROUP_MEMBERS_ERROR,
  ADD_GROUP_MEMBERS_SUCCESS,
  ADD_GROUP_MEMBERS_LOADING,
  REMOVE_GROUP_MEMBERS_ACTION,
  REMOVE_GROUP_MEMBERS_ERROR,
  REMOVE_GROUP_MEMBERS_SUCCESS,
  REMOVE_GROUP_MEMBERS_LOADING,

  NOTIFICATION_COUNT_ACTION,
  NOTIFICATION_COUNT_ERROR,
  NOTIFICATION_COUNT_SUCCESS,
  NOTIFICATION_COUNT_LOADING,
  NOTIFICATION_LIST_ACTION,
  NOTIFICATION_LIST_ERROR,
  NOTIFICATION_LIST_SUCCESS,
  NOTIFICATION_LIST_LOADING,
  MARK_NOTIFICATION_READ_ACTION,
  MARK_NOTIFICATION_READ_ERROR,
  MARK_NOTIFICATION_READ_SUCCESS,
  MARK_NOTIFICATION_READ_LOADING,
  MARK_ALL_NOTIFICATIONS_READ_ACTION,
  MARK_ALL_NOTIFICATIONS_READ_ERROR,
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_READ_LOADING,
  GET_FORTRESS_COMPANIES_ACTION,
  GET_FORTRESS_COMPANIES_ERROR,
  GET_FORTRESS_COMPANIES_SUCCESS,
  GET_FORTRESS_COMPANIES_LOADING,
  UPDATE_FORTRESS_COMPANIES_ACTION,
  UPDATE_FORTRESS_COMPANIES_ERROR,
  UPDATE_FORTRESS_COMPANIES_SUCCESS,
  UPDATE_FORTRESS_COMPANIES_LOADING,
  FORTRESS_BANK_CODE_LIST_ACTION,
  FORTRESS_BANK_CODE_LIST_ERROR,
  FORTRESS_BANK_CODE_LIST_SUCCESS,
  FORTRESS_BANK_CODE_LIST_LOADING,
  UPDATE_FORTRESS_BANK_CODE_ACTION,
  UPDATE_FORTRESS_BANK_CODE_ERROR,
  UPDATE_FORTRESS_BANK_CODE_SUCCESS,
  UPDATE_FORTRESS_BANK_CODE_LOADING,
  DOWNLOAD_EMPLOYEE_STATEMENT_ACTION,
  DOWNLOAD_EMPLOYEE_STATEMENT_ERROR,
  DOWNLOAD_EMPLOYEE_STATEMENT_SUCCESS,
  DOWNLOAD_EMPLOYEE_STATEMENT_LOADING,
  GET_COMPANY_FEES_ACTION,
  GET_COMPANY_FEES_ERROR,
  GET_COMPANY_FEES_SUCCESS,
  GET_COMPANY_FEES_LOADING,
  CREATE_COMPANY_FEES_ACTION,
  CREATE_COMPANY_FEES_ERROR,
  CREATE_COMPANY_FEES_SUCCESS,
  CREATE_COMPANY_FEES_LOADING,
  UPDATE_COMPANY_FEES_ACTION,
  UPDATE_COMPANY_FEES_ERROR,
  UPDATE_COMPANY_FEES_SUCCESS,
  UPDATE_COMPANY_FEES_LOADING,
  DELETE_COMPANY_FEES_ACTION,
  DELETE_COMPANY_FEES_ERROR,
  DELETE_COMPANY_FEES_SUCCESS,
  DELETE_COMPANY_FEES_LOADING
} = constants;


export function buildTypeConstants(constants = []) {
  const obj = {}
  constants.forEach(function (value) {
    value = value.toUpperCase();
    let key = value.toUpperCase();
    const konst = [
      "_ACTION",
      "_LOADING",
      "_ERROR",
      "_SUCCESS"
    ]
    konst.forEach(function (k) {
      obj[value + k] = value + k;
    })

  })
  return obj;
}
